<template>
  <div class="container">
    <div v-if="partName"
         class="title">{{partName}}</div>
    <template v-for="(item, index) in list">
      <div class="row"
           :key="index"
           @click="clickOrgan(item)">
        <div>{{item.organName}}</div>
        <icon :name="item.showList.length > 0 ? 'arrow-down' : 'arrow-up'"></icon>
      </div>
      <div v-for="(pitem, pindex) in item.showList"
           :key="index + '_' + pindex"
           class="row indentation"
           @click="clickDisease(pitem.id)">
        <div>{{pitem.diseaseName}}</div>
        <icon name="arrow"></icon>
      </div>
    </template>
  </div>
</template>

<script>
import { Icon } from 'vant'
import 'vant/lib/icon/style'
import { partOrganList, organDiseaseList } from '@/api/nutrition'
// import wx from 'weixin-js-sdk'

export default {
  name: 'OrganList',
  components: {
    Icon
  },
  props: {
    partId: {
      type: String,
      default: null
    },
    partName: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      list: []
    }
  },
  created() {
    this.init()
  },
  watch: {
    partId() {
      this.init()
    }
  },
  methods: {
    init() {
      if (!this.partId) {
        return
      }
      partOrganList({
        id: this.partId
      }).then(res => {
        if (res.success && res.code == 200) {
          this.list = res.result.map(item => {
            item.diseaseList = []
            item.showList = []
            return item
          })
        }
      })
    },
    clickOrgan(item) {
      if (item.diseaseList.length == 0) {
        organDiseaseList({ id: item.id }).then(res => {
          item.diseaseList = res.result
          item.showList = item.showList.concat(item.diseaseList)
        })
      } else if (item.showList.length > 0) {
        item.showList.splice(0, item.showList.length)
      } else {
        item.showList = item.showList.concat(item.diseaseList)
      }
    },
    clickDisease(id) {
      this.$emit('click', id)
    }
  }
}
</script>

<style scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  background-color: white;
}

.title {
  text-align: center;
  padding: 10px 15px;
  color: #0063aa;
  background-color: white;
  border-bottom: 1px solid #f2f2f2;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 15px;
  color: #666666;
  background-color: white;
  border-bottom: 1px solid #f2f2f2;
}

.indentation {
  margin-left: 15px;
  color: #333333;
}

.row div {
  flex: 1;
}

.row img {
  width: 6px;
  height: 10px;
}
</style>